/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { DimConfigurationFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateDimConfigurationInput = {
  dimensioningKey?: string | null
  id?: string | null
  isActive?: boolean | null
  productName: string
  productType: string
}

export type UpdateDimConfigurationInput = {
  dimensioningKey?: string | null
  isActive?: boolean | null
  productName?: string | null
  productType?: string | null
}

export type CreateDimConfigurationMutationVariables = Exact<{
  input: Types.CreateDimConfigurationInput
}>

export type CreateDimConfigurationMutation = {
  __typename: "Mutation"
  dimConfiguration: {
    __typename: "DimConfiguration"
    id: string
    productName: string
    productType: string
    isActive?: boolean | null
    dimensioningKey?: string | null
  }
}

export type UpdateDimConfigurationMutationVariables = Exact<{
  id: string
  input: Types.UpdateDimConfigurationInput
}>

export type UpdateDimConfigurationMutation = {
  __typename: "Mutation"
  dimConfiguration: {
    __typename: "DimConfiguration"
    id: string
    productName: string
    productType: string
    isActive?: boolean | null
    dimensioningKey?: string | null
  }
}

export type DeleteDimConfigurationMutationVariables = Exact<{
  id: string
}>

export type DeleteDimConfigurationMutation = {
  __typename: "Mutation"
  dimConfiguration: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateDimConfigurationDocument = gql`
  mutation CreateDimConfiguration($input: CreateDimConfigurationInput!) {
    dimConfiguration: createDimConfiguration(input: $input)
      @rest(
        type: "DimConfiguration"
        method: "POST"
        path: "/dimensioning-data-exchange/dim-configuration"
      ) {
      ...DimConfiguration
    }
  }
  ${DimConfigurationFragmentDoc}
`
export type CreateDimConfigurationMutationFn = Apollo.MutationFunction<
  CreateDimConfigurationMutation,
  CreateDimConfigurationMutationVariables
>

/**
 * __useCreateDimConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateDimConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDimConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDimConfigurationMutation, { data, loading, error }] = useCreateDimConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDimConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDimConfigurationMutation,
    CreateDimConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDimConfigurationMutation,
    CreateDimConfigurationMutationVariables
  >(CreateDimConfigurationDocument, options)
}
export type CreateDimConfigurationMutationHookResult = ReturnType<
  typeof useCreateDimConfigurationMutation
>
export type CreateDimConfigurationMutationResult =
  Apollo.MutationResult<CreateDimConfigurationMutation>
export type CreateDimConfigurationMutationOptions = Apollo.BaseMutationOptions<
  CreateDimConfigurationMutation,
  CreateDimConfigurationMutationVariables
>
export const UpdateDimConfigurationDocument = gql`
  mutation UpdateDimConfiguration(
    $id: ID!
    $input: UpdateDimConfigurationInput!
  ) {
    dimConfiguration: updateDimConfiguration(id: $id, input: $input)
      @rest(
        type: "DimConfiguration"
        method: "PUT"
        path: "/dimensioning-data-exchange/dim-configuration/{args.id}"
      ) {
      ...DimConfiguration
    }
  }
  ${DimConfigurationFragmentDoc}
`
export type UpdateDimConfigurationMutationFn = Apollo.MutationFunction<
  UpdateDimConfigurationMutation,
  UpdateDimConfigurationMutationVariables
>

/**
 * __useUpdateDimConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateDimConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDimConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDimConfigurationMutation, { data, loading, error }] = useUpdateDimConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDimConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDimConfigurationMutation,
    UpdateDimConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateDimConfigurationMutation,
    UpdateDimConfigurationMutationVariables
  >(UpdateDimConfigurationDocument, options)
}
export type UpdateDimConfigurationMutationHookResult = ReturnType<
  typeof useUpdateDimConfigurationMutation
>
export type UpdateDimConfigurationMutationResult =
  Apollo.MutationResult<UpdateDimConfigurationMutation>
export type UpdateDimConfigurationMutationOptions = Apollo.BaseMutationOptions<
  UpdateDimConfigurationMutation,
  UpdateDimConfigurationMutationVariables
>
export const DeleteDimConfigurationDocument = gql`
  mutation DeleteDimConfiguration($id: ID!) {
    dimConfiguration: deleteDimConfiguration(id: $id)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/dimensioning-data-exchange/dim-configuration/{args.id}"
      ) {
      success
    }
  }
`
export type DeleteDimConfigurationMutationFn = Apollo.MutationFunction<
  DeleteDimConfigurationMutation,
  DeleteDimConfigurationMutationVariables
>

/**
 * __useDeleteDimConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteDimConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDimConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDimConfigurationMutation, { data, loading, error }] = useDeleteDimConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDimConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDimConfigurationMutation,
    DeleteDimConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDimConfigurationMutation,
    DeleteDimConfigurationMutationVariables
  >(DeleteDimConfigurationDocument, options)
}
export type DeleteDimConfigurationMutationHookResult = ReturnType<
  typeof useDeleteDimConfigurationMutation
>
export type DeleteDimConfigurationMutationResult =
  Apollo.MutationResult<DeleteDimConfigurationMutation>
export type DeleteDimConfigurationMutationOptions = Apollo.BaseMutationOptions<
  DeleteDimConfigurationMutation,
  DeleteDimConfigurationMutationVariables
>
